import  { useEffect } from "react";
import dayjs from 'dayjs'
import parse, { attributesToProps, domToReact } from "html-react-parser";
import Image from 'next/image';

import { cardColors, textColors } from 'src/constants/wall.constant';
import { socialCardKeys } from "src/constants/socialcard.constant";

import classNames from "classnames";

import ReadMoreReadLess from 'src/components/componentHelper/ReadMoreReadLess'

const RedditUpvote = () => (
   <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      style={{ transform: "rotate(360deg)", transition: "all 0.3s ease 0s" }}
      preserveAspectRatio="xMidYMid meet"
      viewBox="0 0 24 24"
   >
      <path
         stroke={"#FF151B"}
         strokeWidth={"1"}
         fill="none"
         d="M4 14h4v7a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-7h4a1.001 1.001 0 0 0 .781-1.625l-8-10c-.381-.475-1.181-.475-1.562 0l-8 10A1.001 1.001 0 0 0 4 14z"
      />
   </svg>
);

const RedditReply = () => (
   <svg
      style={{ margin: "auto" }}
      viewBox="0 0 512 512"
      xmlns="http://www.w3.org/2000/svg"
      width="18px"
      height="15px"
   >
      <path
         fill="var(--ci-primary-color, currentColor)"
         d="M496,496H480a273.39,273.39,0,0,1-179.025-66.782l-16.827-14.584C274.814,415.542,265.376,416,256,416c-63.527,0-123.385-20.431-168.548-57.529C41.375,320.623,16,270.025,16,216S41.375,111.377,87.452,73.529C132.615,36.431,192.473,16,256,16S379.385,36.431,424.548,73.529C470.625,111.377,496,161.975,496,216a171.161,171.161,0,0,1-21.077,82.151,201.505,201.505,0,0,1-47.065,57.537,285.22,285.22,0,0,0,63.455,97L496,457.373ZM294.456,381.222l27.477,23.814a241.379,241.379,0,0,0,135,57.86,317.5,317.5,0,0,1-62.617-105.583v0l-4.395-12.463,9.209-7.068C440.963,305.678,464,262.429,464,216c0-92.636-93.309-168-208-168S48,123.364,48,216s93.309,168,208,168a259.114,259.114,0,0,0,31.4-1.913Z"
         className="ci-primary"
      />
   </svg>
);

const RedditCard = ({ cardItem, cardWidth, fontStyle, cardBackgroundObject, wallId,linkColor, highlightColor, engagementDisabled, darkModeEnabled=false, cardFontColor, darkCardTheme, smallSize, refresh, shortenText,isDateTimeDisabled, ratingColor }) => {

   useEffect(()=>{},[darkModeEnabled])
   
   const options = {
      replace: (domNode) => {
         const attribProps = attributesToProps(domNode.attribs);

         if (domNode.name === "a") {
            return (
             <a {...attribProps} style={linkColor && linkColor!=='#0b57a8'?{color: linkColor} :darkModeEnabled ? { color: '#6fb0f6' } : { color: '#0b57a8' }}>{domToReact(domNode.children, options)}</a>

            );
         }
         else if(domNode.name === 'b'){
            let bStyle = highlightColor ? { backgroundColor: highlightColor } : { backgroundColor: '#fcf807' };
            if (darkModeEnabled) {
              bStyle.color = '#726c6c';
            }
            return <b style={bStyle}>{domToReact(domNode.children, options)}</b>
         }
      },
   };

   return (
      <div
         className={classNames(
            darkModeEnabled ? "border-none" : "border border-gray-200 bg-white",
            "relative z-0 transition-all w-full card-holder "
         )}
         style={{ maxWidth: "39rem", minWidth:cardWidth }}
      >
         <div 
         className={classNames("card social-card-style select-none relative transition-all",(fontStyle && fontStyle!=='')?`font-${fontStyle}`:'')}
         style={cardBackgroundObject? cardBackgroundObject : {}}
         >
            <div style={{minWidth:'48px'}} className="flex items-center padding-bottom--lg padding-bottom--lg">
              {
               cardItem[socialCardKeys.authorImage]?
               <a
                  href={cardItem[socialCardKeys.authorLink]}
                  target="_blank"
                  rel="noreferrer noopener"
               >
                  <Image
                     priority={true}
                     alt=""
                     
                     src={cardItem[socialCardKeys.authorImage]}
                     width="48px" height="48px"
                     style={{ width: "3em", height: "3em", marginRight: "0.75em" }}
                     className="inline object-cover rounded-full transition-all duration-150"
                  />
               </a>
               :
               <a
               href={cardItem[socialCardKeys.authorLink]}
               target="_blank"
               rel="noreferrer noopener"
            >
                               <img  src={`https://ui-avatars.com/api/?name=${encodeURI(cardItem[socialCardKeys.authorName]?cardItem[socialCardKeys.authorName]:'')}&background=d0d0e1&color=47476b&size=48`} alt="" className="overflow-hidden rounded-full w-12 h-12 object-cover" width="48px" height="48px" style={{ minWidth: '3rem' }}/>

            </a>
               }
               <div style={{paddingLeft: '0.75rem'}}>
                  <div
                     className="flex"
                     style={{ fontWeight: 600, color: "#111", lineHeight: 1.2 }}
                  >
                     <div
                        className="whitespace-nowrap"
                        style={{ paddingRight: "0.375em", maxWidth: 320 }}
                     >
                        <h6 className="font-bold text-md inline-flex">
                           <a
                              className="cursor-pointer"
                              href={cardItem[socialCardKeys.authorLink]}
                              style={
                                 !darkModeEnabled
                                    ? {
                                       fontWeight: 600,
                                       color: (cardFontColor || textColors.black.primary),
                                       lineHeight: 1.2,
                                       textDecoration: "none",
                                    }
                                    : {
                                       fontWeight: 600,
                                       color: (cardFontColor || textColors.light.primary),
                                       lineHeight: 1.2,
                                       textDecoration: "none",
                                    }
                              }
                              target="_blank"
                              rel="noreferrer noopener"
                           >{`u/${cardItem[socialCardKeys.authorName]}`}</a>
                        </h6>
                     </div>
                  </div>
                  <a
                     className="reddit-logo cursor-pointer"
                     href={cardItem[socialCardKeys.messageLink]}
                     target="_blank"
                     rel="noreferrer noopener"
                     style={{minWidth:'65px'}}
                  >
                     <svg
                        version="1.1"
                        x="0px"
                        y="0px"
                        width="65"
                        height="65"
                        viewBox="0 0 341.8 341.8"
                        style={{ enableBackground: "new 0 0 341.8 341.8" }}
                     >
                        <g id="Artwork">
                           <g>
                              <circle
                                 style={{ fill: "#FF4500" }}
                                 cx="170.9"
                                 cy="170.9"
                                 r="85.5"
                              />
                              <path
                                 style={{ fill: "#FFFFFF" }}
                                 d="M227.9,170.9c0-6.9-5.6-12.5-12.5-12.5c-3.4,0-6.4,1.3-8.6,3.5c-8.5-6.1-20.3-10.1-33.3-10.6l5.7-26.7
			l18.5,3.9c0.2,4.7,4.1,8.5,8.9,8.5c4.9,0,8.9-4,8.9-8.9c0-4.9-4-8.9-8.9-8.9c-3.5,0-6.5,2-7.9,5l-20.7-4.4c-0.6-0.1-1.2,0-1.7,0.3
			c-0.5,0.3-0.8,0.8-1,1.4l-6.3,29.8c-13.3,0.4-25.2,4.3-33.8,10.6c-2.2-2.1-5.3-3.5-8.6-3.5c-6.9,0-12.5,5.6-12.5,12.5
			c0,5.1,3,9.4,7.4,11.4c-0.2,1.2-0.3,2.5-0.3,3.8c0,19.2,22.3,34.7,49.9,34.7s49.9-15.5,49.9-34.7c0-1.3-0.1-2.5-0.3-3.7
			C224.8,180.4,227.9,176,227.9,170.9z M142.4,179.8c0-4.9,4-8.9,8.9-8.9c4.9,0,8.9,4,8.9,8.9c0,4.9-4,8.9-8.9,8.9
			C146.4,188.7,142.4,184.7,142.4,179.8z M192.1,203.3c-6.1,6.1-17.7,6.5-21.1,6.5c-3.4,0-15.1-0.5-21.1-6.5c-0.9-0.9-0.9-2.4,0-3.3
			c0.9-0.9,2.4-0.9,3.3,0c3.8,3.8,12,5.2,17.9,5.2s14-1.4,17.9-5.2c0.9-0.9,2.4-0.9,3.3,0C193,201,193,202.4,192.1,203.3z
			 M190.5,188.7c-4.9,0-8.9-4-8.9-8.9c0-4.9,4-8.9,8.9-8.9c4.9,0,8.9,4,8.9,8.9C199.4,184.7,195.4,188.7,190.5,188.7z"
                              />
                           </g>
                        </g>
                        <g id="Spacing_Guide" style={{ display: "none" }}>
                           <rect
                              style={{
                                 display: "inline",
                                 fill: "none",
                                 stroke: "#D8D8D8",
                                 strokeWidth: 0.5,
                                 strokeMiterlimit: 10,
                              }}
                              width="85.4"
                              height="85.4"
                           />
                           <rect
                              style={{
                                 display: "inline",
                                 fill: "none",
                                 stroke: "#D8D8D8",
                                 strokeWidth: 0.5,
                                 strokeMiterlimit: 10,
                              }}
                              width="341.8"
                              height="85.4"
                           />
                           <rect
                              y="256.3"
                              style={{
                                 display: "inline",
                                 fill: "none",
                                 stroke: "#D8D8D8",
                                 strokeWidth: 0.5,
                                 strokeMiterlimit: 10,
                              }}
                              width="341.8"
                              height="85.4"
                           />
                           <rect
                              style={{
                                 display: "inline",
                                 fill: "none",
                                 stroke: "#D8D8D8",
                                 strokeWidth: 0.5,
                                 strokeMiterlimit: 10,
                              }}
                              width="85.4"
                              height="341.8"
                           />
                           <rect
                              x="256.4"
                              style={{
                                 display: "inline",
                                 fill: "none",
                                 stroke: "#D8D8D8",
                                 strokeWidth: 0.5,
                                 strokeMiterlimit: 10,
                              }}
                              width="85.4"
                              height="341.8"
                           />
                        </g>
                     </svg>
                  </a>
               </div>
            </div>
            <div
               className="tweet-content"
               style={{
                  color: !darkModeEnabled
                     ? (cardFontColor || textColors.black.primary)
                     : (cardFontColor || textColors.light.primary),
                  fontSize: !smallSize ? "1.15em" : "1.0em",
                  lineHeight: !smallSize ? 1.5 : 1.7,
               }}
            >
               <div className={classNames("content",(fontStyle && fontStyle!=='')?`font-${fontStyle}`:'')} dir="auto">
               {cardItem[socialCardKeys.messageContent] && cardItem[socialCardKeys.messageContent]!==''?
                  shortenText?
                        <ReadMoreReadLess elementId={cardItem[socialCardKeys.uuid]}  refresh={()=>refresh()} text={cardItem[socialCardKeys.messageContent]} parse={parse} options={options} length={300} readMore={"Read More"} readLess={"Read Less"}/>
                        :
                        parse(cardItem[socialCardKeys.messageContent], options)
                  :
                  null
               }
               </div>
               {cardItem[socialCardKeys.messageMediaImage] && (
                  <div className="mt-4 flex justify-center w-full" style={{width: '100%', position: 'relative'}}>
                  <img
                     loading='lazy'
                     className="h-auto w-auto"
                     layout="fill"
                     onLoad={()=>refresh()}
                     objectFit="contain"
                     priority={true}
                     style={{ width: "100%", borderRadius: '10px', objectFit: "contain" }}
                     src={cardItem[socialCardKeys.messageMediaImage]}
                     alt="Post Image"
                  />
                  </div>
               )}
            </div>

            <div className="flex">
               {!engagementDisabled && (
                  <>
                     <div
                        className="whitespace-nowrap flex space-x-1 social-engagement"
                        style={
                           !darkModeEnabled
                              ? {
                                 color: (cardFontColor || textColors.black.secondary),
                                 marginRight: 16,
                                 fontSize: 14,
                              }
                              : {
                                 color: (cardFontColor || textColors.light.secondary),
                                 marginRight: 16,
                                 fontSize: 14,
                              }
                        }
                     >
                        <RedditUpvote />
                        <span
                           className="font-normal"
                           style={
                              !darkModeEnabled
                                 ? { color: (cardFontColor || textColors.black.secondary) }
                                 : { color: (cardFontColor || textColors.light.secondary) }
                           }
                        >
                           {cardItem[socialCardKeys.upvotesCount] || 0}
                        </span>
                     </div>
                     <div
                        className="whitespace-nowrap flex space-x-1 social-engagement"
                        style={
                           !darkModeEnabled
                              ? {
                                 color: (cardFontColor || textColors.black.secondary),
                                 marginRight: 16,
                                 fontSize: 14,
                              }
                              : {
                                 color: (cardFontColor || textColors.light.secondary),
                                 marginRight: 16,
                                 fontSize: 14,
                              }
                        }
                     >
                        <RedditReply />
                        <span
                           className="font-normal"
                           style={
                              !darkModeEnabled
                                 ? { color: (cardFontColor || textColors.black.secondary) }
                                 : { color: (cardFontColor || textColors.light.secondary) }
                           }
                        >
                           {cardItem[socialCardKeys.commentsCount] || 0}
                        </span>
                     </div>
                  </>
               )}
               <div
                  style={
                     !darkModeEnabled
                        ? { color: (cardFontColor || textColors.black.secondary), fontSize: 14 }
                        : { color: (cardFontColor || textColors.light.secondary), fontSize: 14 }
                  }
               >
                  <span className={(fontStyle && fontStyle!=='')?`font-${fontStyle}`:''}>
                     {(!isDateTimeDisabled && cardItem[socialCardKeys.messageTime])
                        ? dayjs(cardItem[socialCardKeys.messageTime])
                           .locale("en")
                           .format("DD MMM YYYY")
                        : null}
                  </span>
               </div>
            </div>
         </div>
      </div>
   );
};

export default RedditCard;
